import React from "react";
import { useTranslation } from "react-i18next";
import Header from "../../../components/header/header";
import Footer from "../../../components/footer/footer";
import BannerComponent from "../../../components/bannerComponent/bannerComponent";
import BenefitsCardsComponent from "../../../components/benefitsCardsComponent/benefitsCardsComponent";
import ButtonLinkComponent from "../../../components/buttonLink/buttonLink";
import "./hire.css";

const HireVMAComponent = () => {
  const { t } = useTranslation();

  const heroData = {
    title: t("UNLOCK_REMOTE_HEALTHCARE"),
    text: t("APPLY_NOW_VMA"),
    className: "hireHeroBanner",
    chipText: t("VMA_HERO_CHIP"),
  };

  const cardBenefitsData = [
    {
      title: t("CAREER_GROWTH_TITLE", { defaultValue: "Crecimiento profesional" }),
      text: t("CAREER_GROWTH_DESC"),
      img: "/img/nurse-portrait-hospital (1) 1.jpg",
    },
    {
      title: t("VIRTUAL_HEALTHCARE_OPPORTUNITIES_TITLE", {
        defaultValue: "Oportunidades en salud virtual",
      }),
      text: t("VIRTUAL_HEALTHCARE_OPPORTUNITIES_DESC"),
      img: "/img/openart-image_DTfxBDRP_1716237432143_raw 1.jpg",
    },
    {
      title: t("REMOTE_HEALTHCARE_OPPORTUNITY_TITLE", {
        defaultValue: "Trabajo remoto con impacto",
      }),
      text: t("REMOTE_HEALTHCARE_OPPORTUNITY_DESC"),
      img: "/img/flag-flies-front-city-skyline 1.jpg",
    },
  ];

  const services = [
    {
      title: t("DAILY_TASK_APPOINTMENTS_TITLE"),
      text: t("SCHEDULE_MANAGE_APPOINTMENTS"),
      icon: "calendarWhite.svg",
    },
    {
      title: t("DAILY_TASK_ADMIN_TITLE"),
      text: t("HANDLE_ADMIN_TASKS"),
      icon: "CheckCalendarWhite.svg",
    },
    {
      title: t("DAILY_TASK_COORDINATION_TITLE"),
      text: t("COORDINATE_WITH_PROVIDERS"),
      icon: "healthTarget.svg",
    },
  ];

  function HireBenefitCard({ img, title, text }) {
    return (
      <article className="hireBenefitCard">
        <div className="hireBenefitMedia">
          <img src={img} alt={title} />
        </div>

        <div className="hireBenefitContent">
          <h3>{title}</h3>
          <p>{text}</p>
        </div>
      </article>
    );
  }

  return (
    <>
      <Header />

      <main className="hirePage">
        <section className="hireHero hireHeroFull">
          <div className="hireHeroBannerFull">
            <BannerComponent
              translateTitle={heroData.title}
              translateText={heroData.text}
              className={heroData.className}
              classNameSide="l"
              translateButton={t("APPLY_NOW")}
              chipText={heroData.chipText}
              url={"/work-with-us"}
              headingTag="h1"
            />
          </div>
        </section>

        <section className="hireAbout">
          <div className="hireAboutWrap">
            <div className="hireSectionIntro">
              <h2>{t("ABOUT_POSITION")}</h2>
              <p>
                {t("ABOUT_POSITION_DESC", {
                  defaultValue:
                    "Conozca más sobre esta oportunidad y descubra cómo puede desarrollar su carrera apoyando servicios de salud virtual.",
                })}
              </p>
            </div>

            <div className="hireBenefitsGrid">
              {cardBenefitsData.map((data, index) => (
                <HireBenefitCard
                  key={index}
                  title={data.title}
                  text={data.text}
                  img={data.img}
                />
              ))}
            </div>
          </div>
        </section>

        <section className="hireTasks">
          <BenefitsCardsComponent
            title={t("YOUR_DAILY_TASKS")}
            cardsData={services}
          />
        </section>

        <section className="hireCta">
          <div className="hireCtaInner">
            <div className="hireCtaContent">
              <h2>
                {t("HIRE_CTA_TITLE", {
                    defaultValue: "Postúlese hoy a esta oportunidad remota",
                })}
                </h2>

                <div className="hireCtaText">
                    <p>{t("HIRE_CTA_TEXT")}</p>
                </div>
            </div>

            <ButtonLinkComponent
              translateButton={t("APPLY_NOW")}
              url={"/work-with-us"}
            />
          </div>
        </section>
      </main>

      <Footer />
    </>
  );
};

export default HireVMAComponent;